import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function ComingSoonPage({
  title = "Coming Soon",
  featureName = "This feature",
  reason = "this feature is being refined before public use.",
}) {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="mx-auto flex min-h-[60vh] max-w-2xl items-center justify-center">
        <Card className="w-full border-border/70">
          <CardContent className="space-y-5 p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-lg border border-primary/20 bg-primary/10 p-2 text-primary">
                <ShieldCheck className="h-5 w-5" aria-hidden="true" />
              </div>
              <div>
                <p className="text-sm font-medium text-primary">{title}</p>
                <h1 className="mt-1 text-2xl font-semibold tracking-normal text-foreground">
                  {featureName} is being refined before public use.
                </h1>
              </div>
            </div>
            <p className="text-sm leading-6 text-muted-foreground">
              Coming Soon - {reason} Investing OS only enables public surfaces when they provide clear educational value and stay inside research-support guardrails.
            </p>
            <p className="rounded-lg border border-border bg-muted/30 p-3 text-xs leading-5 text-muted-foreground">
              These outputs are for education and research support only. They are not financial advice, not a recommendation to buy or sell, and not a guarantee of returns. Always do your own research and make your own final decision.
            </p>
            <Button variant="outline" onClick={() => navigate("/dashboard")} className="gap-2">
              <ArrowLeft className="h-4 w-4" />
              Back to Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

